const toTimestamp = (value) => {
  if (!value) return NaN;
  const timestamp = new Date(value).getTime();
  return Number.isFinite(timestamp) ? timestamp : NaN;
};

export const isActiveBillingPeriod = (period, now = Date.now()) => {
  const periodStart = toTimestamp(period?.period_start);
  const periodEnd = toTimestamp(period?.period_end);
  const nowTimestamp = now instanceof Date ? now.getTime() : now;

  return (
    Number.isFinite(periodStart) &&
    Number.isFinite(periodEnd) &&
    periodStart <= nowTimestamp &&
    nowTimestamp < periodEnd
  );
};

export const pickCanonicalBillingPeriod = (current, candidate) => {
  if (!current) return candidate || null;
  if (!candidate) return current;

  if (current.is_superseded === true && candidate.is_superseded !== true) {
    return candidate;
  }
  if (candidate.is_superseded === true && current.is_superseded !== true) {
    return current;
  }

  const currentComputedAt = toTimestamp(current.last_computed_at);
  const candidateComputedAt = toTimestamp(candidate.last_computed_at);
  if (Number.isFinite(currentComputedAt) && Number.isFinite(candidateComputedAt)) {
    if (candidateComputedAt !== currentComputedAt) {
      return candidateComputedAt > currentComputedAt ? candidate : current;
    }
  } else if (Number.isFinite(candidateComputedAt)) {
    return candidate;
  } else if (Number.isFinite(currentComputedAt)) {
    return current;
  }

  const currentStart = toTimestamp(current.period_start);
  const candidateStart = toTimestamp(candidate.period_start);
  if (!Number.isFinite(currentStart)) return candidate;
  if (!Number.isFinite(candidateStart)) return current;

  return candidateStart > currentStart ? candidate : current;
};

export const selectCanonicalActiveBillingPeriod = (periods, now = Date.now()) =>
  (periods || [])
    .filter((period) => isActiveBillingPeriod(period, now))
    .reduce(pickCanonicalBillingPeriod, null);

export const selectCanonicalActiveBillingPeriodsByOrg = (
  periods,
  now = Date.now(),
) => {
  const byOrg = {};

  for (const period of periods || []) {
    if (!isActiveBillingPeriod(period, now)) continue;
    const orgId = period?.org_pointer?.objectId;
    if (!orgId) continue;
    byOrg[orgId] = pickCanonicalBillingPeriod(byOrg[orgId], period);
  }

  return byOrg;
};
